import { getUserAgent } from './internal';

export const isIE11 = (): boolean => getUserAgent().includes('trident/');

export const isEdge = (): boolean => getUserAgent().includes('edge/');

export const isFirefox = (): boolean => getUserAgent().includes('firefox');

export const isSafari = (): boolean =>
  getUserAgent().includes('safari/') &&
  !getUserAgent().includes('chrome/') &&
  !isEdge();
